<bn-header
  [user]="authService.currentUser()"
  [paths]="paths"
  [appName]="title"
  (leaveFeedback)="openFeedbackDialog()"
></bn-header>
<main class="app-content">
  <router-outlet></router-outlet>
</main>
